import { Typography, Stack, Box } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useTranslation } from "react-i18next"

import sagDiagram from "images/devices/sag/sag-diagram.png"
import sagDiagramLPointV from "images/devices/sag/sag-diagram-L-point-v.png"
import sagDiagramLPointH from "images/devices/sag/sag-diagram-L-point-h.png"

export default function SagDialogContent() {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Stack gap={2} justifyContent="center" padding={1}>
      <Typography>{t("plots_descriptions.SAG")}</Typography>
      <Typography>{t("plots_descriptions.SAG_DIAGRAM.P1.INTRO")}</Typography>
      <Box>
        <Typography
          component="span"
          sx={{ color: theme.palette.primary.main, fontWeight: 500 }}
        >
          • {t("plots_descriptions.SAG_DIAGRAM.P1.SX_LABEL") + " "}
        </Typography>
        <Typography component="span">
          {t("plots_descriptions.SAG_DIAGRAM.P1.SX_DESC")}
        </Typography>
        <br />
        <Typography
          component="span"
          sx={{ color: theme.palette.secondary.main, fontWeight: 500 }}
        >
          • {t("plots_descriptions.SAG_DIAGRAM.P1.SL_LABEL") + " "}
        </Typography>
        <Typography component="span">
          {t("plots_descriptions.SAG_DIAGRAM.P1.SL_DESC")}
        </Typography>
        <br />
        <Typography
          component="span"
          sx={{
            color: theme.palette.extras?.limeGreen?.main || "#7ed957",
            fontWeight: 500,
          }}
        >
          • {t("plots_descriptions.SAG_DIAGRAM.P1.SM_LABEL") + " "}
        </Typography>
        <Typography component="span">
          {t("plots_descriptions.SAG_DIAGRAM.P1.SM_DESC")}
        </Typography>
      </Box>
      <Typography>{t("plots_descriptions.SAG_DIAGRAM.P1.L_DESC")}</Typography>
      <Typography>{t("plots_descriptions.SAG_DIAGRAM.P1.SAG_ZERO_NOTE")}</Typography>
      <Typography>{t("plots_descriptions.SAG_DIAGRAM.P1.IMAGE_NOTE")}</Typography>
      <Box component="img" src={sagDiagram} width="90%" alignSelf="center" />
      <Typography whiteSpace="pre-line">
        {t("plots_descriptions.SAG_DIAGRAM.P2")}
      </Typography>
      <Stack direction="row" justifyContent="space-around" alignItems="center" gap={2}>
        <Box component="img" src={sagDiagramLPointV} width="30%" />
        <Box component="img" src={sagDiagramLPointH} width="30%" />
      </Stack>
    </Stack>
  )
}
